import * as notificationActions from '../store/ducks/notification/actions';
import store from 'store/store';

const handleNotification = (title: string, type?: string): void => {
  store.dispatch(notificationActions.showNotification(title, type));
};

export default handleNotification;
